import { render } from "./CreatorCourseOssView.vue?vue&type=template&id=9947a378&scoped=true"
import script from "./CreatorCourseOssView.vue?vue&type=script&lang=js"
export * from "./CreatorCourseOssView.vue?vue&type=script&lang=js"

import "./CreatorCourseOssView.vue?vue&type=style&index=0&id=9947a378&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9947a378"]])

export default __exports__